export default {
  history: {
    title: "Histórico de Actividad",
    loading: "Cargando…",
    subtitle: "{month} {year} — {days} días con eventos · {total} eventos en total",
    prevMonth: "Mes anterior",
    nextMonth: "Mes siguiente",
    today: "Hoy",
    yesterday: "Ayer",
    loadError: "No se pudo cargar la información. Comprueba tu conexión.",
    retry: "Reintentar",
    changes: "eventos",
    portfolio: "portfolio",
    competitor: "competidor",
    sourceFilter: "Filtrar por fuente",
    allSources: "Todas las fuentes",
    footerSource: "HelixScan vigila {name} desde el {date}. El histórico conserva todos sus eventos desde esa primera comprobación.",
    footerAll: "HelixScan vigila desde el {date}, la fecha de sus primeras fuentes; cada fuente tiene la suya (elige una arriba o mira Fuentes). El histórico conserva todos los eventos desde la primera comprobación de cada fuente.",
    noChanges: "Sin eventos registrados en {month} {year}",
    // Tipos de cambio (leyenda del calendario + tarjetas)
    typeNewEntry: "Nueva entrada",
    typePriceChange: "Cambio precio",
    typeReimbursement: "Financiación",
    typeExclusion: "Exclusión",
    typeDeduction: "Deducción",
    typeWarning: "Nota",
    typeMarketingStatus: "Comercialización",
    typeEuRegistration: "Registro europeo",
    typeRegulation: "Normativa",
    typeExclusivity: "Exclusividad",
    // Meses
    month0: "Enero",
    month1: "Febrero",
    month2: "Marzo",
    month3: "Abril",
    month4: "Mayo",
    month5: "Junio",
    month6: "Julio",
    month7: "Agosto",
    month8: "Septiembre",
    month9: "Octubre",
    month10: "Noviembre",
    month11: "Diciembre",
    // Iniciales de días (L=lunes … D=domingo)
    day0: "L",
    day1: "M",
    day2: "X",
    day3: "J",
    day4: "V",
    day5: "S",
    day6: "D",
  },
};
